import React from 'react';
import { getEntityImage } from '../../utils/assetUtils';
import { cn } from '@/lib/utils';

export const ConciergeRetailerIconGroup = ({
  retailerIds,
  maxSize = 4,
  iconSize = 18,
  buildUnrenderedIconCountString = (hiddenIconCount: number) => `+${hiddenIconCount}`,
}: {
  retailerIds: number[];
  maxSize?: number;
  iconSize?: number;
  buildUnrenderedIconCountString?: (hiddenIconCount: number) => string;
}) => {
  const retailerIdsToRender = retailerIds.slice(0, maxSize);
  const hiddenIconCount = retailerIds.length - maxSize;

  // Calculate width to allow overlapping icons
  const containerWidth = retailerIdsToRender.length * iconSize - iconSize * 0.46 * (retailerIdsToRender.length - 1);

  return (
    <div className={cn('tw:flex tw:items-center')} style={{ isolation: 'isolate' }}>
      <div
        className="tw:flex tw:items-center"
        style={{
          width: `${containerWidth}px`,
        }}
      >
        {retailerIdsToRender.map((retailerId, index) => {
          const shiftOffset = iconSize * 0.46;
          return (
            <img
              key={`retailer-logo-${retailerId}-${index}`}
              src={getEntityImage(retailerId, 'retailer')}
              // Decorative — hide from a11y tree and keep alt empty so a
              // failed CDN load doesn't render the alt text inside the
              // 15-25px icon (which surfaced as a stray "r" glyph for
              // retailer IDs without a logo asset, e.g. Shopify/DTC).
              alt=""
              aria-hidden="true"
              onError={(e) => {
                e.currentTarget.style.display = 'none';
              }}
              className="tw:object-contain tw:rounded-full tw:relative"
              style={{
                width: `${iconSize}px`,
                height: `${iconSize}px`,
                left: `${-shiftOffset * index}px`,
                zIndex: `${retailerIdsToRender.length - index}`,
                mixBlendMode: 'normal', // Override parent's multiply blend mode
              }}
            />
          );
        })}
      </div>

      {hiddenIconCount >= 1 ? (
        <div className="tw:ml-[7px] tw:font-semibold tw:text-[11px]">
          {buildUnrenderedIconCountString(hiddenIconCount)}
        </div>
      ) : null}
    </div>
  );
};
